<style scoped>
.field-fancyChecklist label {
  opacity: 0 !important;
}
</style>

<template>
  <b-form-group class="checkbox-pointer">
    <b-form-checkbox-group
      v-model="value"
      :disabled="disabled"
      :name="schema.model"
      :options="schema.values"
      :required="schema.required"
      :stacked="schema.stacked"
    ></b-form-checkbox-group>
  </b-form-group>
</template>

<script>
import { abstractField } from 'vue-form-generator';

export default {
  mixins: [abstractField],
};
</script>



// WEBPACK FOOTER //
// src/components/custom_fields/general/fieldFancyChecklist.vue